import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Visual pull-to-refresh indicator.
 * Sits at the top of the page content and shows a spinning arrow when pulling down.
 */
export const PullToRefreshIndicator = ({ pullDistance, threshold, isRefreshing }) => {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const progress = Math.min(1, pullDistance / threshold);
  const rotation = progress * 360;
  const ready = pullDistance >= threshold;

  return (
    <div
      className="flex items-center justify-center transition-all duration-150 overflow-hidden"
      style={{ height: isRefreshing ? 48 : pullDistance * 0.6 }}
      data-testid="pull-to-refresh-indicator"
    >
      <div
        className={`flex items-center gap-2 text-sm transition-all ${
          ready || isRefreshing ? 'text-orange-600' : 'text-gray-400'
        }`}
      >
        <RefreshCw
          size={18}
          className={isRefreshing ? 'animate-spin' : ''}
          style={{ transform: isRefreshing ? undefined : `rotate(${rotation}deg)` }}
        />
        <span className="font-medium">
          {isRefreshing ? 'Refreshing...' : ready ? 'Release to refresh' : 'Pull to refresh'}
        </span>
      </div>
    </div>
  );
};
